import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "../../../node_modules/@fortawesome/free-solid-svg-icons/index";

const IUUserMapping = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [flag, setFlag] = useState(false);

  const [iuLevelData, setiuLevelData] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [userTypeData, setUserTypeData] = useState([]);
  const [userRoleData, setUserRoleData] = useState([]);
  const [statesData, setStatesData] = useState([]);
  const [districtData, setDistrictData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [schemeData, setSchemeData] = useState([]);
  const [seasonData, setSeasonData] = useState([]);
  const [blockData, setBlockData] = useState([]);
  const [notifiedVillageData, setNotifiedVillageData] = useState([]);
  const [iuLevelValue, setiuLevelValue] = useState("");
  const [schemeValue, setSchemeValue] = useState("");
  const [seasonValue, setSeasonValue] = useState("");

  const [iuCropCode, setIUCropCode] = useState("");
  const [usersValue, setUsersValue] = useState("");
  const [departmentValue, setDepartmentValue] = useState("");
  const [stateValue, setStateValue] = useState("");
  const [districtValue, setDistrictValue] = useState("");
  const [notifiedVillageValue, setNotifiedVillageValue] = useState("");
  const [blockValue, setBlockValue] = useState("");
  const [level, setLevel] = useState("");
  const [isLoading, setIsLoading] = useState(true)

  const [userTypeValue, setUserTypeValue] = useState("");
  const [userRoleValue, setUserRoleValue] = useState("");
  const [iuCropName, setIUCropName] = useState("");
  const [iUUserMappingCode, setIUUserMappingCode] = useState("");
  const [levelValue, setLevelValue] = useState("");
  const [selectedNotifiedVillage, setSelectedNotifiedVillage] = useState([]);
  const [selectedNotifiedVillageData, setSelectedNotifiedVillageData] =
    useState([]);
  const [yearValue, setYearValue] = useState("");
  let [optionsNotifiedVillage, setOptionsNotifiedVillage] = useState([]);
  const [sssyid, setSssyid] = useState("");

  const [cropicDistrictCodeValue, setCropicDistrictCodeValue] = useState("");

  useEffect(() => {
    if (flag == true) {
      fetchData2();
    }
  }, [flag]);

  useEffect(() => {
    let userTypeCodeLocal = sessionStorage.getItem("userTypeCodeGlobal");
    let OrganizationLevelLocal = sessionStorage.getItem("orgTypeCodeGlobal");
    let StateCodeLocal = sessionStorage.getItem("stateNameGlobal");
    let DstrictCodeLocal = sessionStorage.getItem("districtCodeGlobal");
    getStates();
    handleState(StateCodeLocal);
    handleDistrict(DstrictCodeLocal);

    setStateValue(StateCodeLocal);
    setDistrictValue(DstrictCodeLocal);

    axios
      .post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/district`,
        {
          stateCode: StateCodeLocal,
          districtCode: DstrictCodeLocal,
        }
      )
      .then(function (response) {
        setCropicDistrictCodeValue(
          response.data.dataContent[0].cropicDistrictCode
        );

  

      })
      .catch(function (error) {
        console.log(error);
      });

    var x = document.getElementById("userType");
    var option = document.createElement("option");

    if (userTypeCodeLocal === "1") {
      option.text = "Central";
      option.value = "1";
    } else if (userTypeCodeLocal === "2") {
      option.text = "State";
      option.value = "2";
    } else if (userTypeCodeLocal === "3") {
      option.text = "District";
      option.value = "3";
    } else if (userTypeCodeLocal === "4") {
      option.text = "Block/SubDistrict";
      option.value = "4";
    } else if (userTypeCodeLocal === "5") {
      option.text = "Surveyor";
      option.value = "5";
    }

    x.add(option);

    setUserTypeValue(userTypeCodeLocal);

    var x2 = document.getElementById("Department");
    var option2 = document.createElement("option");

    if (OrganizationLevelLocal === "G") {
      option2.text = "Government";
      option2.value = "G";

      let BlockCodeLocal = sessionStorage.getItem("blockCodeGlobal");
      setBlockValue(BlockCodeLocal);
      // if(document.getElementById("Block")) {
      //   document.getElementById("Block").disabled = true
      // }
    } else {
      option2.text = "Insurance";
      option2.value = "I";
      let BlockCodeLocal = sessionStorage.getItem("blockCodeGlobal");
      setBlockValue(BlockCodeLocal);
    }
    x2.add(option2);

    setDepartmentValue(OrganizationLevelLocal);
  }, []);

  useEffect(() => {
    // useEffect to set defaultValue in dropdown meun
    if (state) {
      console.log("state $$$ scheme", state.IUCode.sssyid)
      console.log("state $$$ scheme", state.IUCode.sssyid.substring(0,2))
      console.log("state $$$ season", state.IUCode.sssyid.substring(3,4))
      setSssyid(state.IUCode.sssyid)
      setYearValue(state.IUCode.mapYear)
      setIUCropCode(state.IUCode.cropCode);
      setSchemeValue(state.IUCode.sssyid.substring(0,2))
      setSeasonValue(state.IUCode.sssyid.substring(3,4))
      //getUserType()
      //getUserRole()
      getUserType();
      getStates();
      getUsers();
      getScheme();
      getSeason();
      //getDesignation()
      setLevel(state.IUCode.iuUserType);
      getDepartment();

      handleNotifiedVillageByUserCode(
        state.IUCode.userCode,
        state.IUCode.iuUserMappingCode
      );
      handleState(state.IUCode.stateCode);
      handleDistrict(state.IUCode.districtCode);

      setBlockValue(state.IUCode.blockCode);

      setUserTypeValue(state.IUCode.userCode);
      //setUserRoleValue(state.IUCode.userRoleCode)
      //setDesignationValue(state.IUCode.designationCode)
      setDistrictValue(state.IUCode.districtCode);
      //setGender(state.IUCode.gender)
      //setVisibility(state.IUCode.isVisible)
      //setIsActive(state.IUCode.isActive)
      setStateValue(state.IUCode.stateCode);
      setUsersValue(state.IUCode.userCode);
      // setSchemeValue(state.IUCode.sssyid.slice(0, 2));
      // setSeasonValue(String(Number(state.IUCode.sssyid.slice(2, 4))));
      setIUCropCode(state.IUCode.cropCode);

      setIUCropName(state.IUCode.cropName);
      setiuLevelValue(state.IUCode.iuLevel);
      setBlockValue(state.IUCode.blockCode);
      setDepartmentValue(state.IUCode.iuDetails);
      // setYearValue("20" + state.IUCode.sssyid.slice(-2));

      setIUUserMappingCode(state.IUCode.iuUserMappingCode);
      // setOptionsNotifiedVillage(state.IUCode.mapNotifiedAreasValues) levelName
      setLevelValue(state.IUCode.levelName);
      handleNotifiedVillage("state", state.IUCode)
     
    }
  }, []);

  function handleNotifiedVillageByUserCode(localUserCode, localIUUserCode) {
    var myHeaders = new Headers();
    myHeaders.append("accept", "*/*");
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      userCode: localUserCode,
      iuUserMappingCode: localIUUserCode,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/iuusersmapping/getAllIUUserMappingByUserCode`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        let localFormData = JSON.parse(result).dataContent;
        let myArray = [];

        if (localFormData) {
          localFormData.map((item, key) => {
            myArray.push({
              label:
                item.cropName +
                "-" +
                item.districtName +
                "-" +
                item.level4Name +
                "-" +
                item.level5Name +
                "-" +
                item.level6Name +
                "-" +
                item.insuranceCompanyName +
                "-" +
                item.notifiedIUName,
              value: item.cropNotificationsID,
              data: item,
            });
          });
        }
     
        setSelectedNotifiedVillage(myArray);
      })
      .catch((error) => console.log("error", error));
  }

  function getUserType() {
    const fetchUserType = async () => {
      const result = await axios(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/usertype`
      );
      setUserTypeData(result.data.dataContent);
    };
    fetchUserType();
  }

  function getStates() {
    const fetchStates = async () => {
      const result = await axios(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Cropicstates`
      );
      setStatesData(result.data.dataContent);
    };
    fetchStates();
  }

  function getUsers() {
    const fetchUsers = async () => {
      const result = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/users/getUsersExtInternalUsers`,
        { userCode: localStorage.getItem("userCodeGlobal") }
      );
      setUsersData(result.data.dataContent);
    };
    fetchUsers();
  }

  function handleState(value) {
    setStateValue(value);
    setDistrictData([]);
    setDistrictValue("");

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      stateCode: Number(value),
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/Cropicdistrict`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setDistrictData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }
  function handleDistrict(value, cropicDistrictCode) {
   
    let dataDistrict = districtData;
    const result = dataDistrict.filter(checkAdult);

    function checkAdult(value) {
      console.log(
        "value@@Fliter",
        value.districtCode === sessionStorage.getItem("districtCodeGlobal")
      );
    }

    setDistrictValue(value);
    // setCropicDistrictCodeValue(cropicDistrictCode)
    var raw = JSON.stringify({
      districtCode: Number(value),
    });

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/CropicLevel4`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        setBlockData(JSON.parse(result).dataContent);
        // handleNotifiedVillage("block", blockCode);
        // setBlockValue(blockValue)
      })
      .catch((error) => console.log("error", error));


  }

  async function fetchData2() {
    const result = await axios(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/users`
    );
    setUsersData(result.data.dataContent);
  }

  function getScheme() {
    const fetchScheme = async () => {
      const result = await axios(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/scheme`
      );
      setSchemeData(result.data.dataContent);
    };
    fetchScheme();
  }

  function getSeason() {
    const fetchSeason = async () => {
      const result = await axios(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/common/GetYearAndSeason`
      );
      setSeasonData(result.data.dataContent[0].seasons);
    };
    fetchSeason();
  }

  function getDepartment() {
    const fetchDepartment = async () => {
      const result = await axios(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/department`
      );
      setDepartmentData(result.data.dataContent);
    };
    fetchDepartment();
  }

  function AddNewIUUserDB() {
    let dataArray = [];
    selectedNotifiedVillage.map((item, index) => {
      dataArray.push(item.data);
    });

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({

      levelName: levelValue,
      mapYear: yearValue,
      sssyid: sssyid,
      stateCode: stateValue,
      districtCode: districtValue,
      iuLevel: "5",
      userCode: usersValue,
      iuDetails: "5",
      blockCode: blockValue ? blockValue : "0",
      createdByUC: localStorage.getItem("userCodeGlobal"),
      iuUserType: sessionStorage.getItem("orgTypeCodeGlobal"),
      mapNotifiedAreasValues: dataArray,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/iuusersmapping/AddIUUserMapping`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        // alert(JSON.parse(result).message);
        if (JSON.parse(result).success == true) {
          setFlag(true);
          alert("IU mapping with Users has been added successfully")
          navigate("/usermanagement/iuusermapping");
        }else {
          alert("IU mapping with Users already exists")
        }
      })
      .catch((error) => console.log("error", error));
  }

  function UpdateIUUserDB() {
    console.log("data###", sssyid, yearValue)
    let dataArray = [];

    selectedNotifiedVillage.map((item, index) => {
      if (item.data) {
        dataArray.push(item.data);
      } else {
        dataArray.push(item);
      }
    });

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      IUUserMappingCode: iUUserMappingCode.toString(),
      levelName: levelValue.toString(),
      mapYear: yearValue.toString(),
      sssyid: state.IUCode.sssyid,
      stateCode: stateValue.toString(),
      districtCode: districtValue.toString(),
      iuLevel: "5",
      userCode: usersValue.toString(),
      iuDetails: "5",
      blockCode: blockValue ? blockValue.toString() : "0",
      createdByUC: localStorage.getItem("userCodeGlobal"),
      iuUserType: sessionStorage.getItem("orgTypeCodeGlobal"),
      mapNotifiedAreasValues: dataArray,
    });

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/iuusersmapping`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        // alert(JSON.parse(result).message);
        if (JSON.parse(result).success == true) {
          setFlag(true);
          alert("IU mapping with Users has been added successfully")
          navigate("/usermanagement/iuusermapping");
        }else {
          alert("IU mapping with Users already exists")
        }
      })
      .catch((error) => console.log("error", error));
  }

  function handleNotifiedVillage(key, sssyIdLocal, districtLocal) {
    console.log("notified $$", key, sssyIdLocal, districtLocal)

    let localSchemeValue = schemeValue;
    let localSeasonValue = seasonValue;
    let localStateValue = stateValue;
    let localYearValue = yearValue.slice(-2);
 
   

    if (String(localSchemeValue).length === 1) {
      localSchemeValue = "0" + localSchemeValue;
    }
    if (String(localSeasonValue).length === 1) {
      localSeasonValue = "0" + localSeasonValue;
    }
  
    if (String(localStateValue).length === 1) {
      localStateValue = "0" + localStateValue;
    }
   
    let sssyidLocalValue =
      localSchemeValue + localSeasonValue + localStateValue + localYearValue;
    key === "district" ? console.log("") : setSssyid(sssyidLocalValue);

   
    var myHeaders = new Headers();
    myHeaders.append("accept", "text/plain");
    myHeaders.append("Content-Type", "application/json");

    if (key === "sssyId") {
      var raw = JSON.stringify({
        // sssyid: sssyIdLocal,
        // districtCode: String(districtLocal),

        sssyid: String(sssyIdLocal),
        stateCode : String(stateValue),
        districtCode: String(districtLocal),
          blockCode: String(blockValue)
      });
    } else if(key === "state"){
      var raw = JSON.stringify({
        sssyid: String(state.IUCode.sssyid),
        stateCode : String(state.IUCode.stateCode),
        districtCode: String(state.IUCode.districtCode),
          blockCode: String(state.IUCode.blockCode)
      });
    }else{
      var raw = JSON.stringify({
        sssyid: String(sssyidLocalValue),
        stateCode : String(stateValue),
        districtCode: String(districtValue),
          blockCode: String(blockValue)
      });
    }

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/iuusersmapping/getIUNotifiedAreaNew`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        setNotifiedVillageData(JSON.parse(result).dataContent);
        handleNotifiedOptions(JSON.parse(result).dataContent);
        setIsLoading(false)
      })
      .catch((error) => console.log("error", error));
  }

  function handleNotifiedOptions(data) {
    let localFormData = data;
    let myArray = [];
    if (localFormData) {
      localFormData.map((item, key) => {
        myArray.push({
          label:
            item.cropName +
            "-" +
            item.districtName +
            "-" +
            item.level4Name +
            "-" +
            item.level5Name +
            "-" +
            item.level6Name +
            "-" +
            item.insuranceCompanyName +
            "-" +
            item.notifiedIUName,
          value: item.cropNotificationsID,
          data: item,
        });
      });
    }

    setOptionsNotifiedVillage(myArray);
  }

  // function handleResetForm() {
  //   setStatesData([]);
  //   setDistrictData([]);
  //   setBlockData([]);
  //   setDepartmentData([]);
  //   setiuLevelData([]);
  //   setSchemeData([]);
  //   setSeasonData([]);
  //   setUserTypeData([]);

  //   setSchemeData([]);
  //   if (!state) {
  //     setUsersData([]);
  //   }
  // }

  function handleValidInfo() {
    if (
      usersValue === ""
      // notifiedVillageValue === ""
    ) {
      alert("Enter all required fields");
    } else {
      state ? UpdateIUUserDB() : AddNewIUUserDB();
    }
  }

  function handleDeleteRow(value) {
    setSelectedNotifiedVillage(
      selectedNotifiedVillage.filter(function (item) {
        return item !== value;
      })
    );
  }

  return (
    <>
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>IU User Mapping</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">User Management</li>
              <li className="breadcrumb-item active">IU User Mapping</li>
            </ol>
          </nav>
        </div>
        <section className="section">
          <div className="card dashboard">
            <div className="card-body">
              <form className="g-3 addNewUser">
                <div className="row">
                  <div className="col-md-4">
                    <label htmlFor="Department" className="form-label">
                      Organization Level
                    </label>
                    <br />

                    <select
                      id="Department"
                      required
                      className="form-select"
                      // onClick={getDepartment}
                      // onChange={(e) => setDepartmentValue(e.target.value)}
                      value={departmentValue}
                      disabled
                    >
                      {state ? "" : <option defaultValue>Choose...</option>}

                      {/* {departmentData.map((item, id) => {
                        return (
                          <option key={id} value={item.deptCode}>
                            {" "}
                            {item.deptName}
                          </option>
                        );
                      })} */}
                    </select>
                  </div>

                  <div className="col-md-4">
                    <label htmlFor="userType" className="form-label">
                      User Type
                    </label>

                    <label htmlFor="userTypeValue" className="form-label">
                      {sessionStorage.getItem("")}
                    </label>
                    <select
                      id="userType"
                      required
                      className="form-select"
                      // onClick={getUserType}
                      // onChange={(e) => setUserTypeValue(e.target.value)}
                      value={userTypeValue}
                      disabled
                    >
                      {state ? "" : <option>Choose...</option>}

                      {/* {userTypeData.map((item, id) => {
                        return (
                          <option key={id} value={item.userTypeCode}>
                            {" "}
                            {item.userTypeName}
                          </option>
                        );
                      })} */}
                    </select>
                  </div>

                  {/* <div className="col-md-3">
                    <label htmlFor="iulevel" className="form-label">
                      Level
                    </label>
                    <select id="iulevel" required className="form-select" onChange={(e) => setLevelValue(e.target.value)} value={levelValue}>
                      <option defaultValue>Choose...</option>
                      <option value="level 3">Level 3</option>
                      <option value="level 4">Level 4</option>
                      <option value="level 5">Level 5</option>
                      <option value="level 6">Level 6</option>
                      <option value="level 7">Level 7</option>
                    </select>
                  </div> */}

                  <div className="col-md-3">
                    <label htmlFor="State" className="form-label">
                      State
                    </label>
                    <select
                      id="State"
                      required
                      className="form-select"
                      // onClick={getStates}
                      // onChange={(e) => handleState(e.target.value)}
                      value={stateValue ? stateValue : ""}
                      disabled
                    >
                      <option defaultValue>Choose...</option>
                      {statesData.map((item, id) => {
                        return (
                          <option key={id} value={item.stateCode}>
                            {" "}
                            {item.stateName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="District" className="form-label">
                      District
                    </label>
                    <select
                      id="District"
                      className="form-select"
                      onChange={(e) =>
                        handleDistrict(
                          e.target.value,
                          e.target.cropicDistrictCode
                        )
                      }
                      value={districtValue ? districtValue : ""}
                      disabled
                    >
                      <option defaultValue>Choose...</option>

                      {districtData.map((item, id) => {
                        return (
                          <option
                            key={id}
                            value={item.districtCode}
                            cropicDistrictCode={item.cropicDistrictCode}
                          >
                            {" "}
                            {item.districtName}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                    <div className="col-md-3">
                      <label htmlFor="Block" className="form-label">
                        Block
                      </label>
                      <select
                        id="Block"
                        className="form-select"
                        onChange={(e) => setBlockValue(e.target.value)}
                        value={blockValue ? blockValue : ""}
                        disabled
                      >
                        <option defaultValue>Choose...</option>

                        {blockData.map((item, id) => {
                          return (
                            <option key={id} value={item.blockCode}>
                              {" "}
                              {item.blockName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  

                  <div className="col-md-3">
                    <label htmlFor="IU_user" className="form-label">
                      User
                    </label>
                    {state ? (
                      <select
                        id="IU_user"
                        className="form-select"
                        onClick={getUsers}
                        onChange={(e) => setUsersValue(e.target.value)}
                        value={usersValue ? usersValue : ""}
                        disabled
                      >
                        <option defaultValue>Choose...</option>
                        {usersData.map((item, id) => {
                          return (
                            <option key={id} value={item.userCode}>
                              {" "}
                              {item.userName}
                            </option>
                          );
                        })}
                      </select>
                    ) : (
                      <select
                        id="IU_user"
                        className="form-select"
                        onClick={getUsers}
                        onChange={(e) => setUsersValue(e.target.value)}
                        value={usersValue ? usersValue : ""}
                      >
                        <option defaultValue>Choose...</option>
                        {usersData.map((item, id) => {
                          return (
                            <option key={id} value={item.userCode}>
                              {" "}
                              {item.userName +
                                "-" +
                                item.desigName +
                                "-" +
                                item.mobile}
                            </option>
                          );
                        })}
                      </select>
                    )}
                  </div>

                  <hr style={{ color: "green" }} />

                  <div className="col-md-4">
                    <label htmlFor="scheme" className="form-label">
                      Scheme
                    </label>
                    <select
                      id="scheme"
                      required
                      className="form-select"
                      onClick={getScheme}
                      onChange={(e) => setSchemeValue(e.target.value)}
                      value={schemeValue}
                    >
                      <option defaultValue>Choose...</option>
                      <option value="02">RWBCIS</option>
                      <option value="04">PMFBY</option>

                      {/* {schemeData.map((item, id) => {
                        return (
                          <option key={id} value={item.schemeCode}>
                            {" "}
                            {item.schemeName}
                          </option>
                        );
                      })} */}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="season" className="form-label">
                      Season
                    </label>
                    <select
                      id="season"
                      required
                      className="form-select"
                      onClick={getSeason}
                      onChange={(e) => setSeasonValue(e.target.value)}
                      value={seasonValue}
                    >
                      <option defaultValue>Choose...</option>
                      {seasonData.map((item, id) => {
                        return (
                          <option key={id} value={item.cropicSeasonCode}>
                            {" "}
                            {item.seasonName}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="col-md-3">
                    <label htmlFor="year" className="form-label">
                      Year
                    </label>
                    <select
                      id="year"
                      className="form-select"
                      onChange={(e) => setYearValue(e.target.value)}
                      onClick={handleNotifiedVillage}
                      value={yearValue}
                    >
                      <option value="Choose..." defaultValue>
                        Choose...
                      </option>
                      <option value="2023">2023</option>
                      <option value="2024">2024</option>
                    </select>
                  </div>

                  {/* <div className="col-md-4">
                    <label htmlFor="notifiedvillage" className="form-label">
                      Notified Village
                    </label>
                    <select
                      id="notifiedvillage"
                      className="form-select"
                      onChange={(e) => setNotifiedVillageValue(e.target.value)}
                      value={notifiedVillageValue}
                    >
                      <option defaultValue>Choose...</option>

                      {notifiedVillageData.map((item, id) => {
                        return (
                          <option key={id} value={item.districtCode}>
              
                            {item.sssyID + "-" + item.cropName + "-" + item.districtName + "-" + item.level4Name + "-" + item.level5Name + "-" + item.level6Name + "-" + item.insuranceCompanyName + "-" + item.notifiedIUName  }
                          </option>
                        );
                      })}
                    </select>
                  </div> */}

                  <div className="col-md-10">
                    <label htmlFor="notifiedvillage" className="form-label">
                      Notified Village (Crop - District - Level4 - Level5 - Level6 - Insurance Company Name - Notified IU Name)
                    </label>

                    <MultiSelect
                      options={optionsNotifiedVillage}
                      value={selectedNotifiedVillage}
                      onChange={setSelectedNotifiedVillage}
                      labelledBy={"Select"}
                      isCreatable={false}
                      // isLoading={isLoading}
                      // noOptions = "Data is getting Loading..."
                      // noOptionsMessage={() => "Data is getting Loading..."}
                    />
                  </div>

                  {selectedNotifiedVillage.length > 0 ? (
                    <table
                      className="table table-borderless datatable"
                      style={{ marginTop: "35px" }}
                    >
                      <thead style={{ backgroundColor: "lightgrey" }}>
                        <tr>
                           <th scope="col">Crop Name</th> 
                           <th scope="col">District Name</th>
                          <th scope="col">&nbsp; &nbsp;Level4</th>
                          <th scope="col">&nbsp; &nbsp;Level5</th>
                          <th scope="col">&nbsp; &nbsp;Level6</th>
                          <th scope="col">&nbsp; &nbsp;Insurance Company Name</th>
                          <th scope="col">Notified IU Name</th>
                          <th scope="col">Operation</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* {selectedNotifiedVillage[0].cropName ? 
                  selectedNotifiedVillage.map((item, index) => {
                   
                   

                    return  <tr key={index}>
                    <th >{item.cropName}</th>
                    <td >{item.districtName}</td>
                    <td>{item.level4Name}</td>
                    <td>{item.level5Name}</td>
                    <td>{item.level6Name}</td>
                    <td>{item.insuranceCompanyName}</td>
                    <td>{item.notifiedIUName}</td>
                    
                    <td><FontAwesomeIcon icon={faTrashAlt} onClick={() => handleDeleteRow(item)} /></td>
                  </tr>
                  })
                  : selectedNotifiedVillage.map((item, index) => {
                
                    let data = item.label.split("-")
                 
                    return  <tr key={index}>
                    <th >{data[0]}</th>
                    <td >{data[1]}</td>
                    <td>{data[2]}</td>
                    <td>{data[3]}</td>
                    <td>{data[4]}</td>
                    <td>{data[5]}</td>
                    <td>{data[6]}</td>
                    
                    <td><FontAwesomeIcon icon={faTrashAlt} onClick={() => handleDeleteRow(item)} /></td>
                  </tr>
                  })}  */}

                        {selectedNotifiedVillage.map((item, index) => {
                          if (item.cropName) {
                            return (
                              <tr key={index}>
                                <th>{item.cropName}</th>
                                <td>{item.districtName}</td>
                                <td>{item.level4Name}</td>
                                <td>{item.level5Name}</td>
                                <td>{item.level6Name}</td>
                                <td>{item.insuranceCompanyName}</td>
                                <td>{item.notifiedIUName}</td>

                                <td>
                                  <FontAwesomeIcon
                                    icon={faTrashAlt}
                                    onClick={() => handleDeleteRow(item)}
                                  />
                                </td>
                              </tr>
                            );
                          } else {
                            let data = item.label.split("-");

                            return (
                              <tr key={index}>
                                <th>{data[0]}</th>
                                <td>{data[1]}</td>
                                <td>{data[2]}</td>
                                <td>{data[3]}</td>
                                <td>{data[4]}</td>
                                <td>{data[5]}</td>
                                <td>{data[6]}</td>

                                <td>
                                  <FontAwesomeIcon
                                    icon={faTrashAlt}
                                    onClick={() => handleDeleteRow(item)}
                                  />
                                </td>
                              </tr>
                            );
                          }
                        })}
                      </tbody>
                    </table>
                  ) : (
                    ""
                  )}

                  <div
                    className="d-grid gap-3 d-md-flex justify-content-md-center"
                    style={{ marginTop: "25px" }}
                  >
                    {state ? (
                      <button
                        className="btn btn-success me-md-2"
                        type="button"
                        onClick={handleValidInfo}
                      >
                        Update
                      </button>
                    ) : (
                      <button
                        className="btn btn-success me-md-2"
                        type="button"
                        onClick={handleValidInfo}
                      >
                        Save
                      </button>
                    )}
                    {/* <button
                      className="btn btn-outline-primary"
                      type="button"
                      onClick={handleResetForm}
                    >
                      Reset
                    </button> */}
                    <button
                      className="btn btn-outline-danger"
                      type="button"
                      onClick={() => navigate("/usermanagement/iuusermapping")}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default IUUserMapping;
